export default __webpack_public_path__ + "static/feature-paths@2x-32edb0393ce562c1e458e2234d4d5b3b.png";